import { Text as ChakraText } from '@chakra-ui/react';
import type { SystemProps } from '@chakra-ui/react';
import type { CommonStyles } from '../../types';
import type { TextSize, TextStyle, TextTypes } from './types';

export interface TextProps extends CommonStyles {
    children?: React.ReactNode;
    /**
     * style
     * - regular: 400
     * - bold: 500
     * - bolder: 600
     * - inherit: 'inherit'
     */
    style?: TextStyle;
    type?: TextTypes;
    size?: TextSize;
    color?: string;
    align?: SystemProps['textAlign'];
    id?: string;
    onClick?: React.MouseEventHandler<HTMLParagraphElement>;
    trim?: boolean;
    maxWidth?: string;
    display?: string;
    className?: string;
}
export const Text = ({
    children,
    style,
    type = 'body',
    size = 'base',
    color = 'slt-pepper.1000',
    align,
    id,
    as = 'span',
    onClick,
    margin,
    padding,
    trim = false,
    wordBreak = 'normal',
    maxWidth,
    display,
    ...restProps
}: TextProps): React.ReactElement => (
    <ChakraText
        data-testid={id}
        textStyle={`${type}-${size}`}
        sx={{
            fontWeight: getFontWeight(style),
            margin,
            padding,
        }}
        display={display ?? 'inline'}
        maxWidth={maxWidth ?? 'unset'}
        color={color}
        as={as}
        onClick={onClick}
        cursor={onClick ? 'pointer' : 'unset'}
        align={align}
        whiteSpace={trim ? 'nowrap' : 'normal'}
        wordBreak={wordBreak}
        {...restProps}
    >
        {children}
    </ChakraText>
);

const fontWeights: Record<TextStyle, number | string> = {
    regular: 400,
    bold: 500,
    bolder: 600,
    inherit: 'inherit',
};

const getFontWeight = (style?: TextStyle): number | string =>
    style ? (fontWeights[style] ?? 'inherit') : 'inherit';

Text.defaultProps = {
    children: undefined,
    style: undefined,
    type: undefined,
    size: undefined,
    color: undefined,
    align: undefined,
    id: undefined,
    onClick: undefined,
    trim: undefined,
    className: undefined,
    maxWidth: undefined,
    display: undefined,
};
